export type InterviewAdmissionFailure = 'no_credits' | 'busy' | 'check_unavailable'

export interface InterviewAdmissionResult {
  canJoin: boolean
  isInterview?: boolean
  reason?: string
  interviewId?: string
}

export const INTERVIEW_LIMIT_MESSAGE = 'Все комнаты сейчас заняты. Попробуйте подключиться позже.'
export const INTERVIEW_CHECK_UNAVAILABLE_MESSAGE = 'Не удалось проверить доступность комнаты. Попробуйте подключиться позже.'

/** The interview limit is mandatory even when the legacy busy guard is disabled. */
export function getInterviewAdmissionFailure(
  result: InterviewAdmissionResult,
  busyGuardEnabled = true,
): InterviewAdmissionFailure | null {
  if (result?.canJoin !== false) return null
  if (result.reason === 'no_credits' || result.reason === 'check_unavailable') return result.reason
  return busyGuardEnabled && result.reason === 'busy' ? 'busy' : null
}
